import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { getElementsForAnimation } from './getElementsForAnimation';

gsap.registerPlugin(ScrollTrigger);

export function inViewAnimations(container = document) {
  let ctx;

  function batch({ selector, from, to, start = 'top 90%' }) {
    const elements = getElementsForAnimation(container, selector);
    if (!elements?.length) return;

    ScrollTrigger.batch(elements, {
      start,
      once: true,
      onEnter: batch =>
        gsap.fromTo(batch, from, {
          ...to,
          clearProps: 'transform,filter'
        })
    });
  }

  ctx = gsap.context(() => {

    // Horizontal
    batch({
      selector: '.iv-st-from-left, .iv-st-from-right',
      from: {
        autoAlpha: 0,
        xPercent: (_, el) =>
          el.classList.contains('iv-st-from-right') ? 100 : -100
      },
      to: {
        duration: 0.7,
        autoAlpha: 1,
        xPercent: 0,
        ease: 'power1.out',
        stagger: 0.1
      }
    });

    // Vertical
    batch({
      selector: '.iv-st-from-top, .iv-st-from-bottom',
      from: {
        autoAlpha: 0,
        filter: 'blur(20px)',
        y: (_, el) =>
          el.classList.contains('iv-st-from-bottom') ? 80 : -80
      },
      to: {
        duration: 1.2,
        autoAlpha: 1,
        filter: 'blur(0px)',
        y: 0,
        ease: 'power1.out',
        stagger: 0.18
      }
    });

    // Image blur
    batch({
      selector: '.iv-image-blur',
      start: 'top 70%',
      from: {
        y: 80,
        autoAlpha: 0,
        filter: 'blur(20px)'
      },
      to: {
        y: 0,
        autoAlpha: 1,
        duration: 1.2,
        filter: 'blur(0px)',
        ease: 'power2.out',
        stagger: 0.18
      }
    });

  }, container);

  ScrollTrigger.refresh();

  return {
    destroy() {
      if (ctx) ctx.revert();
    }
  };
}
